import { Component, OnDestroy, OnInit } from '@angular/core'
import { BranchInformationModel } from '../../models/branch-information.model'
import { OrganizationsService } from '../../services/organizations.service'
import { ActivatedRoute } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { Subscription } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-organization-branch-information',
	templateUrl: './organization-branch-information.component.html',
	styleUrls: ['./organization-branch-information.component.scss'],
})
export class OrganizationBranchInformationComponent
	implements OnInit, OnDestroy
{
	branchInformationData!: BranchInformationModel
	workingHoursEdit = false
	branchId!: number
	subscription = new Subscription()
	workingHouresInvalid = false
	workingHoursData: any = []
	missingDataArray: any = []
	breadCrumbRout: any
	type: number = 1
	constructor(
		private organizationService: OrganizationsService,
		private route: ActivatedRoute,
		private SharedService: SharedService,
		private toaster: ToastrService,
		private translate: TranslateService
	) {
		let rout = this.SharedService.breadCrumbRout.subscribe((res: any) => {
			this.breadCrumbRout = res
		})
		rout.unsubscribe()
	}

	ngOnInit(): void {
		this.subscription.add(
			this.route.params.subscribe((params) => {
				this.branchId = params?.branchId
				this.type = params?.type
			})
		)
		this.getBranchInformation()
	}

	getBranchInformation() {
		this.subscription.add(
			this.organizationService
				.getOrganizationBranchInformation(this.branchId)
				.subscribe((value: any) => {
					this.branchInformationData = value
					this.branchInformationData.workingHours.sort(
						(a, b) => +a.dayOfWeek - +b.dayOfWeek
					)
					this.handleBreadCrumb()
					this.detectMissingData()
				})
		)
	}

	handleBreadCrumb() {
		this.breadCrumbRout['branch-information'] = {
			name: this.branchInformationData?.name,
			id: this.branchId,
			url: '',
			queryParams: null,
		}
		this.SharedService.breadCrumbRout.next(this.breadCrumbRout)
	}

	update() {
		const body: any = {
			id: this.branchInformationData.id,
			tenantID: this.branchInformationData.tenantId,
			...this.workingHoursData,
		}
		this.subscription.add(
			this.organizationService.updateWorkingHours(body).subscribe((res) => {
				this.branchInformationData.workingHours.sort(
					(a, b) => +a.dayOfWeek - +b.dayOfWeek
				)
				// this.branchInformationData.workingHours = this.workingHoursData?.workingHours;
				this.workingHoursEdit = false
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
			})
		)
		this.getBranchInformation()
	}
	detectMissingData() {
		this.missingDataArray = []
		if (
			!this.branchInformationData?.name ||
			!this.branchInformationData?.city?.name?.en
		) {
			this.missingDataArray.push('BASIC_INFORMATION')
		}
		if (
			!this.branchInformationData?.mobileNumbers[0] &&
			!this.branchInformationData?.landline
		) {
			this.missingDataArray.push('CONTACT_NUMBERS')
		}
		if (
			!this.branchInformationData?.latitude ||
			!this.branchInformationData?.longitude
		) {
			this.missingDataArray.push('LOCATION')
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
